import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { getSession, signOut } from "next-auth/react";

export const errorMiddleware: Middleware = () => (next) => async (action) => {
  if (isRejectedWithValue(action)) {
    try {
      const session = (await getSession()) as any;

      if ((action?.payload as any).status === 401 && session?.accessToken) {
        await signOut({
          callbackUrl: "/login",
        });
      }
    } catch (error) {
      console.error("Error in error middleware:", error);
    }
  }

  return next(action);
};
